"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputInnerWrap = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("./layout/FieldLayout");

var _FieldInput = require("./microFields/FieldInput");

var _fieldUtils = require("./microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputInnerWrap = function InputInnerWrap(_ref) {
  var fieldName = _ref.fieldName,
      atts = _ref.atts,
      label = _ref.label,
      helper = _ref.helper,
      doFocus = _ref.doFocus,
      isRequiredField = _ref.isRequiredField,
      isInvalid = _ref.isInvalid,
      showCounter = _ref.showCounter,
      validationProps = _ref.validationProps,
      wrappedElement = _ref.wrappedElement;
  var inputProps = {
    name: fieldName,
    atts: atts,
    label: label,
    helper: helper,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid,
    doFocus: doFocus,
    showCounter: showCounter,
    showValidation: validationProps.showMessage
  };
  return _react.default.createElement(_FieldLayout.FieldDivWrapper, null, _react.default.createElement(_FieldInput.FieldInput, inputProps), wrappedElement || null);
};

exports.InputInnerWrap = InputInnerWrap;
InputInnerWrap.defaultProps = {
  atts: {
    type: 'text'
  },
  helper: '',
  isInvalid: false,
  isRequiredField: true,
  showCounter: false,
  doFocus: false,
  wrappedElement: null // optional element icon/image inside FieldDivWrapper for positioning

};
InputInnerWrap.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  atts: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  helper: _propTypes.default.string,
  isRequiredField: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool.isRequired,
  showCounter: _propTypes.default.bool,
  doFocus: _propTypes.default.bool,
  validationProps: _fieldUtils.validationPropsTypes.isRequired,
  wrappedElement: _propTypes.default.node
};